export default __webpack_public_path__ + "static/media/timePaymentTerms.38884034.png";